import { PASSWORD_GENERATOR_URL } from '@/config/urls/passwordUrls';
import React from 'react';

const vpsOci = {
  myPlan: {
    title: 'Mi plan',
    reboot: 'Reiniciar',
    rebootModal: {
      title: 'Reiniciar máquina (Reboot)',
      message: productName => (
        <>
          <div>
            ¿Está seguro de que desea reiniciar su
            {' '}
            <strong>{productName}</strong>
            ?
          </div>
          <p>
            El reinicio tomará aproximadamente 15 minutos y durante este tiempo todos sus servicios estarán indisponibles.
          </p>
        </>
      ),
      cancel: 'Cancelar',
      checkRebootHistory: 'Ver historial de reinicios',
      confirm: 'Sí, reiniciar ahora',
    },
    rebootHistory: {
      title: 'Historial de reinicios',
      message: prodcutName => (
        <p>
          Últimos reinicios de su
          {' '}
          <strong>
            {prodcutName}
          </strong>
          .
        </p>
      ),
      date: 'Fecha',
      time: 'Hora',
      goBack: 'Volver',
    },
    feedback: {
      loading: 'Puedes cerrar esta ventana. La reinicialización continúa en segundo plano... regresa pronto para seguir.',
      success: '¡VPS reiniciado con éxito!',
      error: 'No se pudo reiniciar ahora. Por favor, inténtelo de nuevo más tarde.',
    },
  },
  status: {
    online: 'Online',
    offline: 'Offline',
    processing: 'Procesando',
  },
  infoVps: {
    title: {
      text: 'Informaciones sobre la VPS',
      tooltip: 'Todo lo que identifica tu servidor.',
    },
    domain: 'Dominio principal',
    serverIp: 'IP asignada',
    datacenter: 'Ubicación del servidor',
    processor: 'Procesador',
    memory: 'Memoria RAM',
    disk: 'Almacenamiento',
  },
  infoSsh: {
    title: {
      text: 'Accesso SSH',
      tooltip: 'Copia esta información para conectarte vía SSH desde el terminal de tu preferencia. Es el camino para acceder directamente al entorno de tu VPS.',
    },
    serverIp: 'IP',
    serverPort: 'Puerto',
    user: 'Usuario',
    password: 'Contraseña',
    changePassword: 'Cambiar contraseña',
    changePasswordModal: {
      title: 'Cambiar la contraseña de acceso SSH',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar nueva contraseña',
      passwordRequirements: 'Tu contraseña debe tener:',
      requirementUppercaseLowercase: 'Incluir caracteres en mayúsculas y minúsculas',
      requirementNumber: 'Incluir al menos 1 número',
      requirementSymbol: 'Incluir al menos 1 símbolo',
      requirementLength: 'Ter al menos 8 caracteres',
      requirementMatch: 'Ser la misma en ambos campos',
      alertMessage: {
        text: 'Si tienes dificultades para generar una contraseña fuerte y segura, consulte nuestro',
        link: {
          text: 'generador de contraseñas.',
          href: PASSWORD_GENERATOR_URL,
        },
      },
      newInstallation: {
        title: 'Define una nueva contraseña de acceso SSH',
        description: '¡La instalación de tu VPS ha sido completada! Ahora, crea una nueva contraseña para acceder vía SSH.',
      },
      cancel: 'Cancelar',
      save: 'Guardar contraseña',
      success: '¡Contraseña de acceso SSH cambiada!',
      error: 'Contraseña de acceso SSH no cambiada. Por favor, inténtelo de nuevo.',
    },
    terminal: {
      buttonLabel: 'Abrir terminal',
      modal: {
        error: {
          title: 'Error al abrir el terminal del navegador',
          message: 'No se pudo cargar el terminal a través del navegador en este momento. Intenta nuevamente más tarde o',
          link: {
            text: 'accede a tu VPS a través de otro terminal de tu preferencia.',
            url: 'https://soporte.hostgator.mx/hc/es-419/articles/28443752291091-C%C3%B3mo-acceder-al-SSH',
          },
          confirmButton: 'Entendido',
        },
      },
    },
  },
  management: {
    title: {
      text: 'Administración',
      tooltip: 'Aquí gestionas el sistema operativo y accedes a paneles o aplicaciones que están añadidos en tu VPS.',
    },
    items: [
      {
        slug: 'so-apps',
        name: 'SO y aplicaciones',
      },
      {
        slug: 'backup',
        name: 'Backup',
        info: 'Última backup: ',
      },
      {
        slug: 'snapshot',
        name: 'Snapshot',
        info: 'Última snapshot: ',
      },
      {
        slug: 'ssh-keys',
        name: 'Claves SSH',
      },
      {
        slug: 'n8n',
        name: 'Acceso n8n',
      },
      {
        slug: 'cpanel',
        name: 'Acceso WHM',
      },
      {
        slug: 'plesk',
        name: 'Acceso Plesk',
      },
      {
        slug: 'wordpress',
        name: 'WordPress',
      },
      {
        slug: 'wordpress-1-clique',
        name: 'WordPress',
      },
      {
        slug: 'wordpress-openlitespeed',
        name: 'WordPress',
      },
      {
        slug: 'docker',
        name: 'Docker',
      },
      {
        slug: 'moodle',
        name: 'Moodle',
      },
      {
        slug: 'node-js',
        name: 'Node.js',
      },
      {
        slug: 'woocommerce',
        name: 'WooCommerce',
      },
      {
        slug: 'pterodactyl',
        name: 'Pterodactyl',
      },
      {
        slug: 'laravel',
        name: 'Laravel',
      },
      {
        slug: 'cyberpanel',
        name: 'CyberPanel',
      },
      {
        slug: 'magento',
        name: 'Magento',
      },
      {
        slug: 'supabase',
        name: 'Supabase',
      },
      {
        slug: 'directadmin',
        name: 'DirectAdmin',
      },
      {
        slug: 'kubernetes-k3s',
        name: 'Kubernetes K3S',
      },
      {
        slug: 'easypanel',
        name: 'EasyPanel',
      },
      {
        slug: 'webmin',
        name: 'Webmin',
      },
      {
        slug: 'virtualmin',
        name: 'Virtualmin',
      },
      {
        slug: 'openclaw',
        name: 'OpenClaw',
      },
      {
        slug: 'gatorclaw',
        name: 'GatorClaw',
      },
    ],
  },
  planDetails: {
    title: 'Detalles del plan',
    registerDate: 'Fecha de contratación',
    nextDueDate: 'Vencimiento en',
    billingCycle: 'Ciclo',
    paymentMethod: 'Forma de pago',
    upgradeButton: 'Hacer upgrade',
    form: {
      title: 'Cambio de plan',
      defaultSelectedNeed: 'Upgrade de Plano - VPS OCI',
    },
    upgrade: {
      listing: {
        benefits: {
          title: 'Elige el nuevo plan ideal para tu VPS',
          description: 'Más recursos, más estabilidad y más rendimiento, sin interrupciones en tu proyecto.',
          resources: {
            title: 'Todos los planes incluyen',
            items: [
              'Transferencia ilimitada',
              'Servidores en la nube',
              '1 IP dedicada',
              'Migración gratuita',
            ],
          },
        },
        planList: {
          prices: {
            separatorText: 'equivalente a',
            suffixText: ' /mes*',
          },
          note: '*Valor mensual aproximado, calculado solo como referencia de acuerdo al ciclo de tu plan actual. Puede variar según las condiciones de pago disponibles.',
          button: 'Realizar upgrade',
          perCycle: {
            monthly: 'por mes',
            quarterly: 'por 3 meses',
            semiAnnually: 'por 6 meses',
            annually: 'por año',
            biennially: 'por 2 años',
            triennially: 'por 3 años',
            oneTime: 'único',
            freeAccount: '',
          },
        },
        messages: {
          noAvailablePlans: 'Este plan de VPS no tiene opciones de upgrade disponibles.',
          error: 'No fue posible cargar las opciones de upgrade en este momento. Por favor, inténtelo de nuevo más tarde.',
        },
      },
      details: {
        aboutUpgrade: {
          title: 'Confirmar upgrade',
          description: 'Revisa todos los detalles y confirma la actualización de tu VPS',
          tags: {
            current: 'Plan actual',
            target: 'Nuevo plan',
          },
        },
        financialSummary: {
          title: 'Resumen financiero',
          proportionalDifference: 'Diferencia proporcional',
          cycle: {
            text: 'Ciclo',
            monthly: '1 mes',
            quarterly: '3 meses',
            semiAnnually: '6 meses',
            annually: '12 meses',
            biennially: '24 meses',
            triennially: '36 meses',
            oneTime: 'único',
            freeAccount: '',
          },
          credits: {
            appliedText: 'Créditos aplicados',
          },
          coupon: {
            placeholder: 'Ingresa tu cupón',
            openInputButton: 'Agregar cupón de descuento',
            discountLabel: 'Descuento por cupón',
            addButton: 'Agregar',
            removeButton: 'Eliminar',
            successMessage: '',
            errorMessage: 'Cupón inválido',
          },
          vatAcronym: 'VAT',
          payment: {
            total: {
              title: 'Valor a pagar ahora (pró-rata)',
              hint: days => (
                <>
                  Cálculo basado en los
                  {' '}
                  <strong>
                    {days}
                    {' '}
                    días restantes
                  </strong>
                  {' '}
                  de tu ciclo
                </>
              ),
            },
            recurring: {
              title: 'Valor recurrente en el próximo ciclo',
              hint: date => `Próxima renovación en ${date}`,
            },
          },
        },
        informations: {
          title: 'Información importante',
          description: (
            <ul>
              <li>La actualización no altera el ciclo de facturación ni la fecha de vencimiento de tu VPS.</li>
              <li>En la próxima renovación, tu VPS se cobrará con los nuevos valores completos del ciclo vigente.</li>
              <li>La actualización se realizará solo después de la confirmación del pago.</li>
              <li>Durante el aprovisionamiento, tu VPS puede estar temporalmente indisponible, sin riesgo de pérdida de datos y sin impacto en paneles o aplicaciones añadidas a la VPS.</li>
            </ul>
          ),
        },
        checkboxConfirmation: 'Entiendo que esta acción es definitiva y que no será posible hacer downgrade posteriormente.',
        buttons: {
          cancel: 'Desistir upgrade',
          confirm: 'Confirmar e ir a pago',
        },
        messages: {
          error: 'NNo fue posible procesar su solicitud de upgrade en este momento. Por favor, inténtelo de nuevo más tarde.',
        },
      },
      resources: {
        suffix: {
          processor: '',
          memory: 'de RAM DDR5',
          disk: 'de almacenamiento NVMe',
        },
      },
      backButton: 'Volver',
      button: 'Realizar upgrade',
    },
  },
  changePlan: {
    hireBanner: {
      title: 'Potencializa la VPS',
      description: 'Agrega el panel cPanel o crea automatizaciones con n8n y lleva el servidor a otro nivel',
      button: 'Contratar',
    },
    form: {
      title: 'Cambio de plan',
      defaultSelectedNeed: 'Cambio de plan',
    },
    upgrade: {
      title: 'Hay una solicitud de upgrade en curso para este servidor',
      description: 'Realice el pago de la factura pendiente. Si ya se ha realizado, espere a que se complete la actualización para realizar un nuevo cambio.',
      action: 'Ver facturas',
    },
  },
  helpLinks: {
    helpCenterButton: 'Acceder al centro de ayuda',
    tourButton: 'Ver tour guiado novamente',
  },
  welcomeModal: {
    title: '¡Bienvenido a tu VPS de HostGator!',
    description: (
      <>
        <p>¡Qué bueno tenerte aquí!</p>
        <p>Este es el panel donde gestionas tu servidor y lo dejas a tu manera. Aquí, puedes instalar aplicaciones, paneles de control o automatizaciones.</p>
        <p>Ahora, te mostraré dónde encontrar las principales informaciones y funcionalidades principales del VPS.</p>
      </>
    ),
    buttonLabel: 'Iniciar tour guiado',
  },
  guidedTour: {
    stepIndicator: (current, total) => `${current} de ${total}`,
    nextButton: 'Siguiente',
    finishButton: 'Entendido',
    steps: [
      {
        title: 'Tu nuevo VPS',
        description: 'Aquí puedes visualizar y controlar el estado de tu servidor y también puedes reiniciar cuando lo necesites.',
      },
      {
        title: 'Datos principales de tu VPS',
        description: (
          <>
            <p>
              Todo lo que identifica tu servidor. Pronto podrás monitorizar el rendimiento de tu VPS desde aquí.
            </p>
            <p>
              <strong>Consejo:</strong>
              {' '}
              el icono ⓘ al lado de los títulos muestra más detalles siempre que lo necesites.
            </p>
          </>
        ),
      },
      {
        title: 'Acceso directo al servidor',
        description: 'Copia estas informaciones para conectarte vía SSH desde el terminal de tu preferencia. Es el camino para acceder directamente al entorno de tu VPS.',
      },
      {
        title: 'Herramientas del día a día',
        description: 'Aquí gestionas el sistema operativo y acceder a paneles o aplicaciones que están añadidas en tu VPS.',
      },
    ],
  },
  openClaw: {
    confirmationTokenPage: {
      title: 'Configurar OpenClaw',
      description: (
        <>
          <span>¡Bienvenido!</span>
          <span>Para que OpenClaw funcione en tu VPS, proporciona las claves de acceso de los servicios de IA. Estas permiten que el agente de IA se conecte y ejecute tareas automáticamente.</span>
        </>
      ),
      inputs: {
        openai: {
          placeholder: {
            desktop: 'Clave de API de OpenAI (OPENAI_API_KEY)',
            mobile: 'Clave de API OpenAI ',
          },
          hint: 'Clave de API de OpenAI para utilizar modelos de IA (obténla en platform.openai.com).',
        },
      },
      observation: 'Tus claves se utilizan solo para autenticación y se almacenan de forma segura en tu entorno.',
      buttons: {
        manualSetupLater: 'Configurar manualmente después',
        confirm: 'Configurar OpenClaw',
      },
      modal: {
        title: 'Configurar manualmente después',
        description: (
          <>
            <span>
              Los tokens son necesarios para que OpenClaw ejecute automatizaciones con IA.
            </span>
            <span>
              Puedes configurarlo manualmente más tarde a través del terminal de la VPS. Sin embargo,
              {' '}
              <strong>esta opción requiere conocimientos técnicos y configuración por línea de comando.</strong>
            </span>
            <span>
              Recomendamos completar la configuración ahora para activar el agente de forma sencilla.
            </span>
          </>
        ),
        buttons: {
          manualSetupLater: 'Configurar manualmente después',
          configureNow: 'Configurar ahora',
        },
      },
      messages: {
        success: 'La clave de API proporcionada ha sido configurada en OpenClaw',
        error: 'Error al intentar configurar OpenClaw. Inténtalo de nuevo.',
      },
    },
  },
  gatorClaw: {
    configurationPage: {
      title: 'Vamos a configurar tu GatorClaw',
      description: 'Para usar GatorClaw en tu VPS, necesitas realizar la configuración inicial. Es un proceso fácil y rápido.',
      terms: {
        prefix: 'Al continuar, aceptas los ',
        linkText: 'términos de uso',
        suffix: ' de GatorClaw.',
      },
      buttons: {
        configure: 'Configurar GatorClaw',
      },
      logoAlt: 'Logo de GatorClaw',
      termsLinkUrl: 'https://suporte.hostgator.com.br/hc/pt-br/articles/49551572161555-Termos-de-Uso-do-GatorClaw',
    },
  },
  store: {
    details: {
      title: 'Sistema operativo y aplicaciones',
      description: 'Los Sistemas Operativos y Aplicaciones definen cómo funciona su VPS y lo que puede hacer. Elija y solicite la instalación o reinstalación según sus necesidades.',
      operationalSystems: {
        almalinux: {
          name: 'AlmaLinux',
          description: 'Alternativa gratuita a RHEL, con enfoque en estabilidad, rendimiento y compatibilidad para entornos empresariales.',
        },
        ubuntu: {
          name: 'Ubuntu',
          description: 'Distribución de Linux basada en Debian, gratuita y fácil de usar, con soporte a largo plazo y enfoque en estabilidad y seguridad.',
        },
        debian: {
          name: 'Debian',
          description: 'Sistema Linux estable y seguro, ideal para servidores y entornos críticos, con paquetes actualizados y soporte de la comunidad.',
        },
        rockylinux: {
          name: 'Rocky Linux',
          description: 'Distribución compatible con RHEL, orientada al uso empresarial, que ofrece alto rendimiento, seguridad y confiabilidad.',
        },
      },
      panels: {
        cpanel: {
          name: 'cPanel',
          description: 'Panel intuitivo y completo para la gestión de sitios y servidores, ideal para hospedajes enfocados en rendimiento y automatización. ',
        },
        plesk: {
          name: 'Plesk',
          description: 'Panel moderno y fácil de usar, permite gestionar sitios, dominios y correos electrónicos con facilidad, integrando recursos de seguridad y copias de seguridad.',
        },
        cyberpanel: {
          name: 'CyberPanel',
          description: 'Distribución de Linux basada en Debian, gratuita y fácil de usar, con soporte a largo plazo y enfoque en estabilidad y seguridad.',
        },
        webmin: {
          name: 'Webmin',
          description: 'Panel de administración basado en la web, versátil y personalizable, ideal para quienes buscan control total del servidor Linux.',
        },
        easypanel: {
          name: 'EasyPanel',
          description: 'Panel ligero e intuitivo, dirigido a usuarios que desean simplicidad en la gestión de servidores y sitios.',
        },
        virtualmin: {
          name: 'Virtualmin',
          description: 'Panel completo y flexible, dirigido a usuarios que necesitan control avanzado en la gestión de servidores, dominios y servicios integrados.',
        },
      },
      applications: {
        n8n: {
          name: 'n8n',
          description: 'Herramienta de automatización lista para usar, permite crear flujos e integraciones entre sistemas sin código.',
        },
        'wordpress-1-clique': {
          name: 'WordPress 1-clic',
          description: 'Instalación rápida y automática de WordPress, ideal para crear sitios y blogs en pocos minutos.',
        },
        'wordpress-openlitespeed': {
          name: 'WordPress optimizado con LiteSpeed/OLS',
          description: 'Versión ajustada para máximo rendimiento y velocidad, con caché LiteSpeed nativo y alta eficiencia.',
        },
        docker: {
          name: 'Docker',
          description: 'Plataforma que empaqueta aplicaciones y sus entornos en contenedores, garantizando portabilidad y ejecución consistente en cualquier servidor.',
        },
        'node-js': {
          name: 'Node.js',
          description: 'Entorno que permite ejecutar JavaScript en el servidor para crear APIs y aplicaciones rápidas y ligeras, ideal para desarrolladores y proyectos modernos.',
        },
        moodle: {
          name: 'Moodle',
          description: 'Plataforma educativa de código abierto, perfecta para crear y gestionar cursos y entornos de aprendizaje en línea.',
        },
        pterodactyl: {
          name: 'Pterodactyl',
          description: 'Panel de gestión de servidores de juegos, seguro y sencillo, orientado a la hospedaje de juegos.',
        },
        magento: {
          name: 'Magento',
          description: 'Plataforma de comercio electrónico, optimizada para rendimiento y escalabilidad en grandes tiendas en línea.',
        },
        supabase: {
          name: 'Supabase',
          description: 'Backend de código abierto completo con autenticación, base de datos y API, alternativa moderna a Firebase.',
        },
        laravel: {
          name: 'Laravel',
          description: 'Framework PHP elegante y productivo, ideal para el desarrollo rápido de aplicaciones web seguras.',
        },
        'kubernetes-k3s': {
          name: 'Kubernetes K3S',
          description: 'Sistema de orquestación de contenedores que automatiza la implementación, escalabilidad y gestión de aplicaciones.',
        },
        woocommerce: {
          name: 'WooCommerce',
          description: 'Plataforma de comercio electrónico flexible y personalizable, basada en WordPress, ideal para tiendas en línea de pequeño a gran tamaño, con una amplia variedad de plugins, temas e integraciones.',
        },
        openclaw: {
          name: 'OpenClaw',
          description: 'Agente de IA flexible y personalizable, de código abierto, ejecutado en VPS, con memoria persistente, integraciones y operación autónoma en nombre del usuario.',
        },
        gatorclaw: {
          name: 'GatorClaw',
          description: 'Con GatorClaw, usas todo el poder de OpenClaw en una interfaz visual amigable e intuitiva desarrollada por HostGator para facilitar tu camino con IA.',
        },
      },
    },
    currentSo: {
      title: 'Sistema operativo actual',
      addons: {
        title: 'Agregado a su Sistema Operativo',
        application: 'Aplicación',
      },
    },
    changeApplications: {
      title: 'Cambiar sistema operativo o aplicación',
      description: 'En este momento, para cambiar el sistema operativo de su VPS, es necesario abrir un ticket con el equipo de soporte. Seleccione el sistema deseado para ser redirigido al formulario de apertura.',
      tabs: {
        operationalSystems: 'SO Simple',
        panels: 'SO con Panel',
        applications: 'Aplicación',
      },
      modal: {
        operationalSystems: {
          title: 'Cambiar el sistema operativo',
          placeholder: {
            versions: 'Selecciona la versión',
          },
          withoutSelectionOfVersion: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          withSelectionOfVersion: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          confirmWithoutPanelPaidActive: {
            message: (
              <>
                Al instalar un nuevo sistema operativo,
                {' '}
                <strong>todo lo que está guardado en tu VPS será borrado</strong>
                , incluyendo archivos, configuraciones, paneles y aplicaciones.
              </>
            ),
            agreedTerms: [
              {
                text: 'Soy consciente de que todo será borrado de forma permanente para la instalación del nuevo sistema operativo.',
                id: 'beDeleted',
              },
            ],
            closeButton: 'Volver',
            confirmButton: 'Instalar ahora',
          },
          confirmWithPanelPaidActive: {
            message: (formattedAddonsText = '') => (
              <>
                Al instalar un nuevo sistema operativo,
                {' '}
                <strong>todo lo que está guardado en tu VPS será borrado</strong>
                , incluyendo archivos, configuraciones, paneles y aplicaciones.
                <br />
                <br />
                El nuevo sistema operativo no incluye el
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por lo tanto,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'sus licencias serán canceladas' : 'tu licencia será cancelada'}
                </strong>
                {' '}
                y el valor restante reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (so = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Soy consciente de que todos los datos serán borrados de forma permanente para la instalación del nuevo sistema operativo con
                    {' '}
                    <strong>{so}</strong>
                    {' '}
                    y que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'las licencias' : 'la licencia'}
                    {' '}
                    del
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'serán canceladas' : 'será cancelada'}
                    , con reembolso proporcional del valor restante.
                  </>
                ),
                id: 'beDeleted',
              },
            ],
            closeButton: 'Volver',
            confirmButton: 'Instalar ahora',
          },
        },
        panels: {
          title: 'Instalar sistema operativo con panel',
          placeholder: {
            optionsAccounts: 'Opciones de cuentas',
            paymentFrequency: 'Periodicidad de pago',
          },
          qtyAccountsText: seats => `Hasta ${seats} cuentas`,
          provisioned: so => (
            <>
              Panel provisionado en
              {' '}
              <strong>{so}</strong>
            </>
          ),
          selectionPanels: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          confirmWithoutPanelPaidActive: {
            message: (panel = '') => (
              <>
                Al instalar un nuevo sistema operativo con
                {' '}
                <strong>{panel}</strong>
                ,
                {' '}
                <strong>todo lo que está guardado en tu VPS será borrado</strong>
                , incluyendo archivos, configuraciones, paneles y aplicaciones.
              </>
            ),
            agreedTerms: (panel = []) => [
              {
                text: (
                  <>
                    Soy consciente de que todo será borrado de forma permanente para la instalación del nuevo sistema operativo con
                    {' '}
                    <strong>{panel}</strong>
                  </>
                ),
                id: 'beDeleted',
              },
              {
                text: 'Entiendo que la instalación solo se llevará a cabo después de la compensación del pago, y que el plazo puede variar según el método elegido.',
                id: 'paymentAcknowledgment',
              },
            ],
            closeButton: 'Volver',
            confirmButtonPayment: 'Ir a pago',
            confirmButtonInstall: 'Instalar ahora',
          },
          confirmWithPanelPaidActive: {
            message: (panel = '', formattedAddonsText = '') => (
              <>
                Al instalar un nuevo sistema operativo con
                {' '}
                <strong>{panel}</strong>
                ,
                {' '}
                <strong>todo lo que está guardado en tu VPS será borrado</strong>
                , incluyendo archivos, configuraciones, paneles y aplicaciones.
                <br />
                <br />
                El nuevo sistema operativo no incluye el
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por lo tanto,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'sus licencias serán canceladas' : 'tu licencia será cancelada'}
                </strong>
                {' '}
                y el valor restante reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (panel = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Soy consciente de que todos los datos serán borrados de forma permanente para la instalación del nuevo sistema operativo con
                    {' '}
                    <strong>{panel}</strong>
                    {' '}
                    y que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'las licencias' : 'la licencia'}
                    {' '}
                    del
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'serán canceladas' : 'será cancelada'}
                    , con reembolso proporcional del valor restante.
                  </>
                ),
                id: 'beDeleted',
              },
              {
                text: 'Entiendo que la instalación solo se realizará después de la compensación del pago, y que el plazo puede variar según el método elegido.',
                id: 'paymentAcknowledgment',
              },
            ],
            closeButton: 'Volver',
            confirmButtonPayment: 'Ir a pago',
            confirmButtonInstall: 'Instalar ahora',
          },
        },
        applications: {
          title: 'Instalar sistema operativo con aplicación',
          provisioned: so => (
            <>
              Aplicación provisionada en
              {' '}
              <strong>{so}</strong>
            </>
          ),
          selectionApplication: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          selectionDomain: {
            message: 'Esta aplicación necesita un dominio para funcionar correctamente. Elige cómo deseas continuar.',
            closeButton: 'Volver',
            confirmButton: 'Continuar',
            alreadyHasDomain: {
              label: 'Usar un dominio que ya tengo',
              input: {
                label: 'Ingresa tu dominio',
                helpText: '(ej.: tudominio.com)',
                errorMessage: 'Ingresa un dominio válido.',
              },
            },
            needToRegisterDomain: {
              label: 'Registrar un nuevo dominio',
              description: (
                <>
                  <p>¿No tienes un dominio aún? Puedes registrar uno ahora. Serás dirigido a la contratación de dominio y la instalación de la aplicación se interrumpirá.</p>
                  <p>Después de registrar el dominio, vuelve a la selección de aplicaciones e inicia la instalación nuevamente usando el dominio comprado.</p>
                </>
              ),
            },
          },
          confirmWithoutPanelPaidActive: {
            message: (application = '') => (
              <>
                Al instalar un nuevo sistema operativo con
                {' '}
                <strong>{application}</strong>
                ,
                {' '}
                <strong>todo lo que está guardado en tu VPS será borrado</strong>
                , incluyendo archivos, configuraciones, paneles y aplicaciones.
              </>
            ),
            agreedTerms: (application = '') => [
              {
                text: (
                  <>
                    Soy consciente de que todo será borrado de forma permanente para la instalación del nuevo sistema operativo con
                    {' '}
                    <strong>{application}</strong>
                  </>
                ),
                id: 'beDeleted',
              },
              {
                text: 'Entiendo que la instalación solo se llevará a cabo después de la compensación del pago, y que el plazo puede variar según el método elegido.',
                id: 'paymentAcknowledgment',
              },
            ],
            closeButton: 'Volver',
            confirmButton: 'Ir a pago',
          },
          confirmWithPanelPaidActive: {
            message: (application = '', formattedAddonsText = '') => (
              <>
                Al instalar un nuevo sistema operativo con
                {' '}
                <strong>{application}</strong>
                ,
                {' '}
                <strong>todo lo que está guardado en tu VPS será borrado</strong>
                , incluyendo archivos, configuraciones, paneles y aplicaciones.
                <br />
                <br />
                El nuevo sistema operativo no incluye el
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por lo tanto,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'sus licencias serán canceladas' : 'tu licencia será cancelada'}
                </strong>
                {' '}
                y el valor restante reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (application = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Soy consciente de que todos los datos serán borrados de forma permanente para la instalación del nuevo sistema operativo con
                    {' '}
                    <strong>{application}</strong>
                    {' '}
                    y que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'las licencias' : 'la licencia'}
                    {' '}
                    del
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' y ') ? 'serán canceladas' : 'será cancelada'}
                    , con reembolso proporcional del valor restante.
                  </>
                ),
                id: 'beDeleted',
              },
            ],
            closeButton: 'Volver',
            confirmButton: 'Ir a pago',
          },
        },
      },
    },
    rebuild: {
      title: 'Rebuild (reinstalación)',
      description: 'El rebuild recrea su VPS desde cero utilizando el mismo sistema operativo. Este proceso sirve para restaurar el entorno original y corregir posibles errores de configuración o rendimiento.',
      button: 'Hacer rebuild ahora',
      modal: {
        confirmRebuild: {
          title: 'Rebuild VPS',
          message: (
            <>
              Al realizar el rebuild, tu VPS será recreada desde cero con
              {' '}
              <strong>el mismo Sistema Operativo</strong>
              . Todos los datos y configuraciones serán borrados de forma irreversible.
            </>
          ),
          agreedTerms: [
            {
              text: 'Tengo conocimiento de que todo será borrado de forma permanente para la reinstalación del sistema operativo.',
              id: 'beDeleted',
            },
          ],
          closeButton: 'Cerrar',
          confirmButton: 'Hacer rebuild',
        },
        serverInactive: {
          title: 'VPS no disponible',
          message: 'La VPS está inactiva en este momento. Actívela para continuar.',
          confirmButton: 'Entendido',
        },
        limitExceeded: {
          title: 'Límite diario de rebuilds alcanzado',
          message: (
            <>
              Ha alcanzado el
              {' '}
              <strong>límite de dos rebuilds</strong>
              {' '}
              (reinstalaciones del sistema operativo, ya sea el actual o uno nuevo) en las últimas 24 horas. Podrá realizar una nueva mañana.
            </>
          ),
          confirmButton: 'Entendido',
        },
        notFound: {
          title: 'Su VPS está fuera de línea',
          message: 'La VPS está inactiva en este momento. Actívela para continuar.',
          confirmButton: 'Entendido',
        },
        unknownError: {
          title: 'Rebuild no concluido',
          message: 'No fue posible concluir el rebuild de tu VPS. Intenta nuevamente en unos instantes.',
          closeButton: 'Cerrar',
          confirmButton: 'Intentar nuevamente',
        },
      },
      feedback: {
        loading: 'Rebuild en progreso. Esto puede tardar unos minutos. Espere...',
      },
    },
    modal: {
      alert: {
        backup: {
          title: '¡Esta acción no podrá deshacerse!',
          message: 'Antes de continuar, haz una copia de seguridad de todos tus archivos e información importante.',
          backup: {
            text: 'Consultar cómo hacer una copia de seguridad.',
            link: 'https://soporte-latam.hostgator.com/hc/es-419/articles/115000322691',
          },
        },
      },
    },
  },
  form: {
    changePlan: {
      title: 'Cambio de plan',
      defaultSelectedNeed: 'Cambio de plan',
    },
  },
  messages: {
    vpsNotFound: 'VPS no encontrada. Por favor, verifique si el servicio está activo o contacte al soporte.',
  },
};

export default { vpsOci };
